import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-outlined-green-button',
  templateUrl: './outlined-green-button.component.html',
  styleUrls: ['./outlined-green-button.component.css'],
})
export class OutlinedGreenButtonComponent {
  @Input() label: string;
  @Output() click = new EventEmitter<void>();
  @Input() width: String = '103px';
  @Input() height: String = '41px';
  @Input() radius: string = '100px';
  @Input() styles: string | object;
  @Input() borderColor: string = 'var(--primaryColor)';

  onClick() {
    this.click.emit();
  }
}
